<bn-loading-overlay></bn-loading-overlay>

<div class="container" *ngIf="acompanhamentos">
    <div class="row">
        <div class="col">
            <h5>Posição da Carteira em Recuperação de Crédito</h5>
        </div>

        <div class="col-auto">
            <button type="button" class="btn btn-danger" 
                (click)="cancelar()">Cancelar
            </button>
            
            <button type="button" class="btn btn-primary" 
                (click)="salvar()" [disabled]="!modoEdicao" *ngIf="acompanhamentos.length > 0 && acompanhamentos.length <= limiteOperacoesCadastroViaTela">Salvar
            </button>
        </div>
    </div>

    <div class="alert alert-info" *ngIf="acompanhamentos.length > limiteOperacoesCadastroViaTela">
        Cadastro via tela não é possível para {{acompanhamentos.length}} operações.
    </div>

    <div class="alert alert-info" *ngIf="acompanhamentos.length == 0">
        Não há operações para atualização.
    </div>

    <div *ngIf="acompanhamentos.length > 0 && acompanhamentos.length <= limiteOperacoesCadastroViaTela">
        <div class="row painel-acompanhamento" *ngFor="let acompanhamento of acompanhamentos; let i = index">
            <div class="bn-form-group col-md-3">
                <label><b>Operação</b></label>
                <input type="text" class="form-control" value="{{acompanhamento.idOperacaoAgenteCreditoLivre ? acompanhamento.idOperacaoAgenteCreditoLivre : acompanhamento.sistemaRepasse + ' ' + acompanhamento.contratoRepasse}}" disabled>
            </div>
            
            <div class="bn-form-group col-md-3">
                <label><b>Sistema</b></label>
                <select name="sistemaRepasse" id="sistemaRepasse" class="form-select" [(ngModel)]="acompanhamento.sistemaRepasse" disabled>
                    <option [ngValue]="'15'">15 - Contratos FINAME</option>
                    <option [ngValue]="'89'">89 - Contratos BNDES</option>
                    <option [ngValue]="undefined">Crédito Livre</option>
                </select>
            </div>

            <div class="bn-form-group col-md-3">
                <label><b>Saldo Devedor Total</b></label>
                <input type="text" class="form-control" name="valorSaldoDevedorTotal{{i}}" [(ngModel)]="acompanhamento.valorSaldoDevedorTotal" bnMask="MOEDA" [disabled]="!modoEdicao" />
            </div>

            <div class="bn-form-group col-md-3">
                <label><b>Saldo Devedor de Principal</b></label>
                <input type="text" class="form-control" name="valorSaldoDevedorDePrincipal{{i}}" [(ngModel)]="acompanhamento.valorSaldoDevedorDePrincipal" bnMask="MOEDA" [disabled]="!modoEdicao" />
            </div>

            <div class="bn-form-group col-md-3">
                <label><b>Saldo de Juros na Normalidade</b></label>
                <input type="text" class="form-control" name="valorSaldoDeJurosNaNormalidade{{i}}" [(ngModel)]="acompanhamento.valorSaldoDeJurosNaNormalidade" bnMask="MOEDA" [disabled]="!modoEdicao" />
            </div>

            <div class="bn-form-group col-md-3">
                <label><b>Saldo de Encargos Moratórios</b></label>
                <input type="text" class="form-control" name="valorSaldoDeEncargosMoratorios{{i}}" [(ngModel)]="acompanhamento.valorSaldoDeEncargosMoratorios" bnMask="MOEDA" [disabled]="!modoEdicao" />
            </div>

            <div class="bn-form-group col-md-3">
                <label><b>Tipo da Cobrança</b></label>
                <select class="form-select" name="tipoCobranca{{i}}" [(ngModel)]="acompanhamento.tipoCobranca" (change)="tipoCobrancaAlterado(acompanhamento)" [disabled]="!modoEdicao">
                    <option [ngValue]="undefined"></option>
                    <option [ngValue]="tipoCobranca.codigo" *ngFor="let tipoCobranca of tiposCobranca">
                        {{tipoCobranca.label}}
                    </option>
                </select>
            </div>

            <div class="bn-form-group col-md-3">
                <label><b>Cobrança Encerrada</b></label>
                <input type="checkbox" class="form-check checkbox-gigante" name="cobrancaEncerrada{{i}}" [(ngModel)]="acompanhamento.cobrancaEncerrada" [disabled]="!modoEdicao" />
            </div>

            <div class="bn-form-group col-md-6">
                <label><b>Fase Processual</b></label>
                <select class="form-select" name="faseProcessual{{i}}" [(ngModel)]="acompanhamento.faseProcessual" [disabled]="!modoEdicao || acompanhamento.tipoCobranca == 'E'">
                    <option [ngValue]="undefined"></option>
                    <option [ngValue]="faseProcessual.codigo" *ngFor="let faseProcessual of fasesProcessuais">
                        {{faseProcessual.descricao}}
                    </option>
                </select>
            </div>

            <div class="bn-form-group col-md-6">
                <label><b>Espécie Ação / Recurso</b></label>
                <select class="form-select" name="especieAcaoRecurso{{i}}" [(ngModel)]="acompanhamento.especieAcaoRecurso" [disabled]="!modoEdicao || acompanhamento.tipoCobranca == 'E'">
                    <option [ngValue]="undefined"></option>
                    <option [ngValue]="especieAcaoRecurso.codigo" *ngFor="let especieAcaoRecurso of especiesAcaoRecurso">
                        {{especieAcaoRecurso.descricao}}
                    </option>
                </select>
            </div>

            <div class="bn-form-group col-md-4">
                <label><b>Número do Processo</b></label>
                <input type="text" class="form-control" name="numeroProcesso" [(ngModel)]="acompanhamento.numeroProcesso" [disabled]="!modoEdicao || acompanhamento.tipoCobranca == 'E'" />
            </div>

            <div class="bn-form-group col-md-4">
                <label><b>Juízo</b></label>
                <input type="text" class="form-control" name="juizo" [(ngModel)]="acompanhamento.juizo" [disabled]="!modoEdicao || acompanhamento.tipoCobranca == 'E'" />
            </div>

            <div class="bn-form-group col-md-4">
                <label><b>Comarca</b></label>
                <input type="text" class="form-control" name="comarca" [(ngModel)]="acompanhamento.comarca" [disabled]="!modoEdicao || acompanhamento.tipoCobranca == 'E'" />
            </div>

            <div class="bn-form-group col-md-12">
                <label><b>Observações</b></label>
                <textarea class="form-control" name="observacoes" [(ngModel)]="acompanhamento.observacoes" rows="3" [disabled]="!modoEdicao"></textarea>
            </div>

        </div>
    </div>
</div>

<div class="container" *ngIf="ocorrencias?.length > 0">
    <div class="table-responsive">
    <table class="table-striped table-bordered">
        <thead>
        <tr>
            <th class="text-center" colspan="2">
            Erro(s) encontrado(s)
            </th>
        </tr>
        </thead>
        <tbody>
        <tr *ngFor="let ocorrencia of ocorrencias">
            <td width="20%">
                {{ ocorrencia.idObjetoValidado }}
            </td>
            <td width="80%">
                {{ ocorrencia.mensagem }}
            </td>
        </tr>
        </tbody>
    </table>
    </div>
</div>

<div class="container" *ngIf="acompanhamentos && acompanhamentos.length > 1">
    <div class="row">
        <div class="col">
        </div>
        <div class="col-auto">
            <button type="button" class="btn btn-danger" 
                (click)="cancelar()">Cancelar
            </button>
            
            <button type="button" class="btn btn-primary" 
                (click)="salvar()" [disabled]="!modoEdicao" *ngIf="acompanhamentos.length > 0 && acompanhamentos.length <= limiteOperacoesCadastroViaTela">Salvar
            </button>
        </div>
    </div>
</div>

<div class="loading-pesquisa" *ngIf="!acompanhamentos">
    <i class="bn-loading"></i>
</div>